/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ticket': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M.443 19.8l3.535 3.535.472-.471a2.99 2.99 0 014.242 0 2.99 2.99 0 010 4.242l-.471.472 3.535 3.535 19.8-19.8-3.535-3.535-.471.471a2.99 2.99 0 01-4.243 0 2.99 2.99 0 010-4.243l.472-.47L20.242 0 .443 19.8zm1.886 0l12.02-12.021 9.43 9.429-12.021 12.02-1.702-1.701c1.235-1.693 1.106-4.08-.42-5.606-1.526-1.526-3.92-1.663-5.613-.427L2.329 19.8zM15.293 6.836l4.95-4.95 1.694 1.694c-1.236 1.693-1.1 4.088.427 5.614 1.526 1.526 3.912 1.655 5.605.42l1.702 1.701-4.95 4.95-9.428-9.43z" _fill="#BECD47"/>'
  }
})
